import { useEffect, useLayoutEffect, useRef } from 'react';

import _ from 'lodash';

export const { isEqual } = _;

export const useDeepCompareEffect = (effect, deps, depsEqual = _.isEqual) => {
  const ref = useRef(undefined);

  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps;
  }

  useEffect(effect, ref.current);
};

export const useDeepCompareLayoutEffect = (effect, deps, depsEqual = _.isEqual) => {
  const ref = useRef(undefined);

  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps;
  }

  useLayoutEffect(effect, ref.current);
};
